import { useState, useEffect, useCallback } from 'react';

export const useInfiniteScroll = () => {
  const [loading, setLoading] = useState(false);
  const [hasMore, setHasMore] = useState(true);

  const handleScroll = useCallback((fetchMore) => {
    if (loading || !hasMore) return;

    const { scrollTop, scrollHeight, clientHeight } = document.documentElement;
    
    // Trigger when user is 1000px from bottom
    if (scrollTop + clientHeight >= scrollHeight - 1000) {
      fetchMore();
    }
  }, [loading, hasMore]);

  const setupScrollListener = useCallback((fetchMore) => {
    const scrollHandler = () => handleScroll(fetchMore);
    
    window.addEventListener('scroll', scrollHandler);
    return () => window.removeEventListener('scroll', scrollHandler);
  }, [handleScroll]);

  const resetScroll = useCallback(() => {
    setHasMore(true);
    setLoading(false);
  }, []);

  return {
    loading,
    setLoading,
    hasMore,
    setHasMore,
    setupScrollListener,
    resetScroll
  };
};